import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0f35d44c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-info" }
const _hoisted_2 = { class: "cm-ui-dialog-title" }
const _hoisted_3 = { class: "team-head cm-ui-rise-in cm-ui-rise-in--d1" }
const _hoisted_4 = {
  class: "team-head__seal-base",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "team-head__meta" }
const _hoisted_6 = { class: "team-head__name-line" }
const _hoisted_7 = { class: "team-head__editor" }
const _hoisted_8 = {
  key: 0,
  class: "team-head__error"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = {
  key: 0,
  class: "team-head__chip"
}
const _hoisted_12 = {
  key: 0,
  class: "team-strip cm-ui-rise-in cm-ui-rise-in--d2"
}
const _hoisted_13 = { class: "row-label" }
const _hoisted_14 = { class: "info-list" }
const _hoisted_15 = { class: "form-row cm-ui-rise-in cm-ui-rise-in--d3" }
const _hoisted_16 = { class: "row-label" }
const _hoisted_17 = { class: "row-value" }
const _hoisted_18 = { class: "row-value__editor" }
const _hoisted_19 = {
  key: 0,
  class: "row-value__error"
}
const _hoisted_20 = ["title"]
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = { class: "form-row cm-ui-rise-in cm-ui-rise-in--d4" }
const _hoisted_23 = { class: "row-label" }
const _hoisted_24 = { class: "row-value" }
const _hoisted_25 = { class: "row-value__editor" }
const _hoisted_26 = {
  key: 0,
  class: "row-value__error"
}
const _hoisted_27 = ["title"]
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = {
  key: 0,
  class: "form-row cm-ui-rise-in cm-ui-rise-in--d5"
}
const _hoisted_30 = { class: "row-label" }
const _hoisted_31 = { class: "row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_Copy = _resolveComponent("Copy")!
  const _component_SmsVerify = _resolveComponent("SmsVerify")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('centralControl.teamInfo')), 1),
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.monogram), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.nameEdit)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_input, {
                      ref: "nameNode",
                      class: "team-head__name-input",
                      size: "small",
                      type: "text",
                      maxlength: "30",
                      modelValue: _ctx.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                      onKeyup: _withKeys(_ctx.saveName, ["enter"]),
                      onBlur: _ctx.saveName
                    }, null, 8, ["modelValue", "onKeyup", "onBlur"])
                  ]),
                  (_ctx.nameErrorFlag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.t('teamInfoEdit.nameLengthError')), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("strong", {
                    class: "team-head__name",
                    title: _ctx.name,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleEditName && _ctx.handleEditName(...args)))
                  }, _toDisplayString(_ctx.name), 9, _hoisted_9),
                  _createElementVNode("button", {
                    type: "button",
                    class: "team-head__edit",
                    "aria-label": _ctx.t('common.edit'),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEditName && _ctx.handleEditName(...args)))
                  }, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/_components/central-control/_images/edit",
                      monochrome: "",
                      size: 18
                    })
                  ], 8, _hoisted_10)
                ], 64))
          ]),
          (_ctx.teamInfo.role_name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.teamInfo.role_name), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_CmSvgIcon, {
          class: "team-head__seal",
          name: "views/dashboard/_components/central-control/_components/team-info-edit/_images/seal",
          monochrome: "",
          size: 108,
          "aria-hidden": "true"
        })
      ]),
      (!_ctx.IS_PRIVATE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_CmSvgIcon, {
                name: "views/dashboard/_components/central-control/_images/pin",
                monochrome: "",
                size: 18
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t('overviewZone.teamPinCode')), 1)
            ]),
            _createVNode(_component_Copy, { class: "team-strip__value" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.pin_code), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("dl", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("dt", _hoisted_16, [
            _createVNode(_component_CmSvgIcon, {
              name: "views/dashboard/_components/central-control/_images/exit",
              monochrome: "",
              size: 18
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.t('teamInfoEdit.exitPassword')), 1)
          ]),
          _createElementVNode("dd", _hoisted_17, [
            (_ctx.exitCodeEdit)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_input, {
                      ref: "exitCodeNode",
                      class: "row-value__input",
                      size: "small",
                      type: "text",
                      maxlength: "30",
                      modelValue: _ctx.exitCode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.exitCode) = $event)),
                      onKeyup: _withKeys(_ctx.saveExitCode, ["enter"]),
                      onBlur: _ctx.saveExitCode
                    }, null, 8, ["modelValue", "onKeyup", "onBlur"])
                  ]),
                  (_ctx.exitCodeErrorFlag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.t('teamInfoEdit.codeFormatError')), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", {
                    class: "row-value__text",
                    title: _ctx.exitCode,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleEditExitCode && _ctx.handleEditExitCode(...args)))
                  }, _toDisplayString(_ctx.exitCode), 9, _hoisted_20),
                  _createElementVNode("button", {
                    type: "button",
                    class: "row-value__edit",
                    "aria-label": _ctx.t('common.edit'),
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleEditExitCode && _ctx.handleEditExitCode(...args)))
                  }, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/_components/central-control/_images/edit",
                      monochrome: ""
                    })
                  ], 8, _hoisted_21)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("dt", _hoisted_23, [
            _createVNode(_component_CmSvgIcon, {
              name: "views/dashboard/_components/central-control/_images/lock",
              monochrome: "",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.t('teamInfoEdit.uninstallLeaveTeamPassword')), 1)
          ]),
          _createElementVNode("dd", _hoisted_24, [
            (_ctx.unInstallCodeEdit)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_el_input, {
                      ref: "uninstallCodeNode",
                      class: "row-value__input",
                      size: "small",
                      type: "text",
                      maxlength: "25",
                      modelValue: _ctx.uninstallCode,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uninstallCode) = $event)),
                      onKeyup: _withKeys(_ctx.saveUninstallCode, ["enter"]),
                      onBlur: _ctx.saveUninstallCode
                    }, null, 8, ["modelValue", "onKeyup", "onBlur"])
                  ]),
                  (_ctx.uninstallCodeErrorFlag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.t('teamInfoEdit.codeFormatError')), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", {
                    class: "row-value__text",
                    title: _ctx.uninstallCode,
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleEditUninstallCode && _ctx.handleEditUninstallCode(...args)))
                  }, _toDisplayString(_ctx.uninstallCode), 9, _hoisted_27),
                  _createElementVNode("button", {
                    type: "button",
                    class: "row-value__edit",
                    "aria-label": _ctx.t('common.edit'),
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleEditUninstallCode && _ctx.handleEditUninstallCode(...args)))
                  }, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/_components/central-control/_images/edit",
                      monochrome: ""
                    })
                  ], 8, _hoisted_28)
                ], 64))
          ])
        ]),
        (!_ctx.IS_PRIVATE && _ctx.teamInfo.is_creator)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("dt", _hoisted_30, [
                _createVNode(_component_CmSvgIcon, {
                  name: "views/dashboard/_components/central-control/_images/setting",
                  monochrome: "",
                  size: 18
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.t('listColumns.operation')), 1)
              ]),
              _createElementVNode("dd", _hoisted_31, [
                _createElementVNode("button", {
                  type: "button",
                  class: "text-button text-button--danger",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteTeam && _ctx.deleteTeam(...args)))
                }, _toDisplayString(_ctx.t('teamInfoEdit.deregisterTeam')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_SmsVerify, {
      modelValue: _ctx.smsVerifyVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.smsVerifyVisible) = $event)),
      "confirm-button-text": _ctx.t('teamInfoEdit.confirmDeregisterSms'),
      "use-current-phone": "",
      onConfirm: _ctx.confirmVerifyDeleteTeam
    }, null, 8, ["modelValue", "confirm-button-text", "onConfirm"])
  ], 64))
}